<template>
  <section v-if="shopItems">
    <div class="shop container">
      <div class="circleHeader">
        <h2>Shop our store<br>
          and support the show!</h2>
      </div>
      <div class="moduleItems">
        <a target="_blank" v-for="item in shopItems" :href="item.link || 'https://www.podswag.com/collections/longest-shortest-time'">
          <span class="img" :style="{ backgroundImage: `url(${ featured(item.image) })`}"></span>
          <span class="shopContent">
            <span v-html="item.name"></span>
            <span v-html="item.price"></span>
          </span>
        </a>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'shop-module',
  computed: {
    ...mapGetters([
      'shopItems'
    ])
  },
  methods: {
    featured (value) {
      if (value && value.sizes) {
        let image = value.sizes.large
        if (process.env.NODE_ENV === 'development') {
          image = image.replace('http://longestshortesttime.duck/app', 'http://cdn.longestshortesttime.com/wp-content')
        }
        return image
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
  @import ../../assets/styles/colors
  @import ../../assets/styles/mixins

  .shop
    padding: 60px 15px 30px
    +tablet
      padding: 60px 30px 30px
    +desktop
      padding: 136px 0 164px
    .circleHeader
      margin-bottom: 30px
      +tablet
        margin-bottom: 82px
      &:before
        background-color: $orange
    .moduleItems
      +tablet
        display: flex
        justify-content: space-around
      +desktop
        justify-content: space-between
      > a
        color: inherit
        font-size: 19px
        line-height: 32px
        font-weight: bold
        letter-spacing: 0.2px
        margin-bottom: 30px
        display: flex
        align-items: center
        &:hover
          color: lighten($textColor, 25%)
          .img
            filter: brightness(115%)
        +tablet
          font-size: 25px
          display: block
          margin-bottom: 0
          text-align: center
        span
          display: block
        .shopContent
          +until($tablet)
            flex: 1
            margin-left: 12px
            line-height: 1.25
            span:first-child
              font-size: 22px
        .img
          display: block
          background: #fff
          border: 8px solid $orange
          border-radius: 50%
          background-size: cover
          background-position: center center
          margin: 10px auto
          width: 120px
          height: 120px
          +tablet
            width: 210px
            height: 210px
          +desktop
            margin: 0 0 32px
            width: 290px
            height: 290px
</style>



// WEBPACK FOOTER //
// ShopModule.vue?27b39550